<!-- Hero Start -->
<section class="home-slider position-relative" id="home">
  <div id="carouselExampleInterval" class="carousel slide" data-bs-ride="carousel">
    <div class="carousel-inner">
      <owl-carousel-o id="customer-testi" [options]="customOptions">
        <ng-template carouselSlide>
          <div class="bg-home d-flex align-items-center"
            style="background: url('assets/images/WeChacaito/fachada.jpg') center center fixed;background-size: cover;">
            <div class="bg-overlay"></div>
            <div class="row justify-content-center">
              <div class="col-lg-12 text-center">
                <div class="title-heading mt-4">
                  <h6 class="text-white-50 para-dark animated fadeInDownBig animated.delay-2s">La nueva forma de trabajar en <span class="text-success">Venezuela</span></h6>
                  <h1 class="heading mb-3 text-white title-dark animated fadeInUpBig animation-delay-3">WeCode</h1>
                  <!-- <p class="para-desc mx-auto text-white-50 para-dark animated fadeInUpBig animated.delay-4s">Launch your
                    campaign and benefit from our expertise on designing and managing conversion centered bootstrap v5
                    html page.</p> -->
                  <div class="mt-4 pt-2 animated fadeInUpBig animation-delay-11">
                    <a target="_blank" href="https://miembros.wecode.network/" class="btn btn-primary mt-2"><i class="uil uil-eye"></i> Nuestros Planes</a>
                  </div>
                </div>
              </div>
              <!--end col-->
            </div>
          </div>
          <!--end slide-->
        </ng-template>
      </owl-carousel-o>
    </div>
  </div>
</section>
<!--end section-->
<!-- Hero End -->


<!-- Partners start -->
<!-- <section class="py-5 border-bottom border-top">
  <div class="container">
    <div>
      <div class="row justify-content-center">
        @for(men of menu;track $index){
          <a [href]="men.link" *ngIf="men.isExternal === true" target="_blank" class="col-lg-2 col-md-2 col-6 text-center">
            <label for="">{{men.title}}</label>
            <img src="#" class="avatar avatar-ex-sm" alt="">
          </a>
          <a [href]="" *ngIf="men.isFragment === false && men.isExternal === false" [routerLink]="men.link"  class="col-lg-2 col-md-2 col-6 text-center">
            <label for="">{{men.title}}</label>
            <img src="#" class="avatar avatar-ex-sm" alt="">
          </a>
          <a [href]="" *ngIf="men.isFragment === true" routerLink="{{men.link}}" fragment="{{men.fragment}}" class="col-lg-2 col-md-2 col-6 text-center">
            <label for="">{{men.title}}</label>
            <img src="#" class="avatar avatar-ex-sm" alt="">
          </a>
        }
      </div>
    </div>
  </div>
</section> -->
<!--end section-->
<!-- Partners End -->



<section class="section" id="espacios">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12">
        <div class="section-title text-center mb-4 pb-2">
          <h4 class="title mb-4">Nuestros Espacios</h4>
          <!-- <p class="text-muted para-desc mx-auto mb-0">Start working with <span
              class="text-primary fw-bold">Landrick</span> that can provide everything you need to generate
            awareness, drive traffic, connect.</p> -->
        </div>
      </div>
      <!--end col-->
    </div>
    <!--end row-->
    <div class="row">
      @for(sucursal of sucursales;track $index){  
      <div class="col-lg-3 col-md-6 mt-4 pt-2">
          <div class="card text-center border-0">
            <div class="position-relative" href="javascript:void(0)" data-bs-toggle="modal" [attr.data-bs-target]="'#salas'+sucursal.id" style="cursor: pointer;">
              <img [src]="sucursal.urlImg" class="avatar avatar-ex-large rounded-circle shadow" style="object-fit: cover;"
                alt="">
              <!-- <ul class="list-unstyled mb-0 team-icon">
                @for(item of data.list;track $index){ 
                <li class="list-inline-item ms-1"><a href="javascript:void(0)" class="btn btn-primary btn-pills btn-sm btn-icon">
                    <i-feather name="{{item}}" class="icons"></i-feather>
                  </a></li>
                }
              </ul> -->
              <!--end icon-->
            </div>
            <div class="card-body py-3 px-0 content">
              <h5 class="mb-0">
                <a href="javascript:void(0)" data-bs-toggle="modal" [attr.data-bs-target]="'#salas'+sucursal.id" class="name text-dark">{{sucursal.title}}</a>
              </h5>
              <!-- <small class="designation text-muted">{{sucursal.designation}}</small> -->
            </div>
          </div>
        </div>
      }
    </div>
  </div>
  <!--end container-->
</section>
<!--end section-->

<!-- Services Start -->
<section class="section bg-light" id="membresia">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12 text-center">
        <div class="section-title mb-4 pb-2">
          <h3 class="title mb-4">La Membresia Incluye</h3>
          <!-- <p class="text-muted para-desc mx-auto mb-0">Start working with <span
              class="text-primary fw-bold">Landrick</span> that can provide everything you need to generate awareness,
            drive traffic, connect.</p> -->
        </div>
      </div>
      <!--end col-->
    </div>
    <!--end row-->

    <div class="row">
      <div class="col-12 col-md-4">
        <div ngbAccordion activeIds="div ngbAccordionItem-0" closeOthers="true">
          <div *ngFor="let feature of featuresOne" ngbAccordionItem
              cardClass="border-0 rounded shadow mb-2">
              <h2 ngbAccordionHeader>
                <div class="border-0 bg-light" id="heading{{feature.id}}">
                  <button ngbAccordionButton class="title mb-0 accordion-items">
                    <i class="uil {{feature.icon}} h1" [ngClass]="feature.filterColor"></i> {{feature.title}}
                      </button>
                  </div>
              </h2>
              <div ngbAccordionCollapse>
                  <div ngbAccordionBody>
                      <ng-template class="text-muted mb-0 faq-ans">
                        <p>{{feature.description}}</p>
                      </ng-template>
                  </div>
              </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-4">
        <div ngbAccordion activeIds="div ngbAccordionItem-0" closeOthers="true">
          <div *ngFor="let feature of featuresTwo" ngbAccordionItem
              cardClass="border-0 rounded shadow mb-2">
              <h2 ngbAccordionHeader>
                <div class="border-0 bg-light" id="heading{{feature.id}}">
                  <button ngbAccordionButton class="title mb-0 accordion-items">
                    <i class="uil {{feature.icon}} h1" [ngClass]="feature.filterColor"></i> {{feature.title}}
                      </button>
                  </div>
              </h2>
              <div ngbAccordionCollapse>
                  <div ngbAccordionBody>
                      <ng-template class="text-muted mb-0 faq-ans">
                        <p>{{feature.description}}</p>
                      </ng-template>
                  </div>
              </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-4">
        <div ngbAccordion activeIds="div ngbAccordionItem-0" closeOthers="true">
          <div *ngFor="let feature of featuresThree" ngbAccordionItem
              cardClass="border-0 rounded shadow mb-2">
              <h2 ngbAccordionHeader>
                <div class="border-0 bg-light" id="heading{{feature.id}}">
                  <button ngbAccordionButton class="title mb-0 accordion-items">
                    <i class="uil {{feature.icon}} h1" [ngClass]="feature.filterColor"></i> {{feature.title}}
                      </button>
                  </div>
              </h2>
              <div ngbAccordionCollapse>
                  <div ngbAccordionBody>
                      <ng-template class="text-muted mb-0 faq-ans">
                        <p>{{feature.description}}</p>
                      </ng-template>
                  </div>
              </div>
          </div>
        </div>
      </div>
      <!-- <div *ngFor="let feature of features" class="col-lg-3 col-md-4 col-12 mt-4 pt-2">
        <div class="features text-center pt-3 pb-3">
          <i class="uil {{feature.icon}} h1" [ngClass]="feature.filterColor"></i>
          <div class="content mt-3">
            <h5>{{feature.title}}</h5>
            <p>
              {{feature.description}}
            </p>
          </div>
        </div>
      </div> -->
    </div>
    <!--end row-->
  </div>
  <!--end container-->
</section>
<!--end section-->
<!-- Services End -->


 <!-- Start Price -->
 <div class="container mt-60" id="oursPlans" style="margin-top: 2rem;">
  <div class="row justify-content-center">
    <div class="col-12 text-center">
      <div class="section-title mb-4 pb-2">
        <h4 class="title mb-4">{{ourPlans.title}}</h4>
        <!-- <p class="text-muted para-desc mb-0 mx-auto">Start working with <span
            class="text-primary fw-bold">Landrick</span> that can provide everything you need to generate awareness,
          drive traffic, connect.</p> -->
      </div>
    </div>
    <!--end col-->
  </div>
  <!--end row-->

  <!-- Testi n Download cta start -->
  <section class="section pt-0">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <owl-carousel-o id="customer-testi" [options]="customOptionsPlans">
            <ng-template *ngFor="let plan of ourPlans.paragraph"  carouselSlide>
              <div class="card pricing-rates best-plan rounded text-center border-0" [ngClass]="plan.filterColor">
                <div class="card-body py-5">
                  <img [src]="plan.urlImg" class="mb-4 " style="display:inline;filter: drop-shadow(1px 1px 1px black);" height="50" alt="">
                  <h2 class="title text-par-card text-uppercase mb-4" style="text-shadow: 2px 2px #000000;">{{plan.title}}</h2>
                  <div class="d-flex justify-content-center mb-4">
                    <!-- <span class="h4 mb-0 mt-2">$</span>
                    <span class="price h1 mb-0">19</span> -->
                    <!-- <span class="h4 align-self-end mb-1">/mo</span> -->
                  </div>
        
                  <p class="text-par-card">{{plan.description}}</p>
                </div>
                <div class="card-footer">
                  <a [href]="plan.urlBtn" target="_blank" class="btn btn-cards btn-sm">Ver Plan</a>
                </div>
              </div>
            </ng-template>
          </owl-carousel-o>
          <!-- </div> -->
        </div>
        <!--end col-->
      </div>
      <!--end row-->
    </div>
    <!--end container-->
  </section>
  <!--end section-->
  <!-- Testi n Download cta End -->
</div>
<!--end container-->
<!-- End Price -->
<!-- About Start -->
<section class="section bg-light mt-100" id="whatOffert">
  <div class="container mt-100 mt-60">
    <div class="row align-items-center">
      <div class="col-lg-6 col-md-6">
        <div class="row align-items-center">
          <div class="col-lg-6 col-6 mt-4 mt-lg-0 pt-2 pt-lg-0">
            <div class="card work-container work-modern overflow-hidden rounded border-0 shadow-md">
              <div class="card-body p-0">
                <img src="assets/images/WeChacaito/Recepcion w.jpg" class="img-fluid" alt="work-image">
                <div class="overlay-work bg-dark"></div>
                <div class="content">
                  <!-- <a href="javascript:void(0)" class="title text-white d-block fw-bold">Web Development</a>
                  <small class="text-light">IT & Software</small> -->
                </div>
              </div>
            </div>
          </div>
          <!--end col-->
  
          <div class="col-lg-6 col-6">
            <div class="row">
              <div class="col-lg-12 col-md-12 mt-4 mt-lg-0 pt-2 pt-lg-0">
                <div class="card work-container work-modern overflow-hidden rounded border-0 shadow-md">
                  <div class="card-body p-0">
                    <img src="assets/images/WeChacaito/unnamed.jpg" style="width: 100%;height: 100%;" class="img-fluid" alt="work-image">
                    <div class="overlay-work bg-dark"></div>
                    <div class="content">
                      <!-- <a href="javascript:void(0)" class="title text-white d-block fw-bold">Michanical
                        Engineer</a>
                      <small class="text-light">Engineering</small> -->
                    </div>
                  </div>
                </div>
              </div>
              <!--end col-->
  
              <div class="col-lg-12 col-md-12 mt-4 pt-2">
                <div class="card work-container work-modern overflow-hidden rounded border-0 shadow-md">
                  <div class="card-body p-0">
                    <img src="assets/images/WeChacaito/Recepcion CCCT 134.JPG" class="img-fluid" alt="work-image">
                    <div class="overlay-work bg-dark"></div>
                    <div class="content">
                      <!-- <a href="javascript:void(0)" class="title text-white d-block fw-bold">Chartered
                        Accountant</a>
                      <small class="text-light">C.A.</small> -->
                    </div>
                  </div>
                </div>
              </div>
              <!--end col-->
            </div>
            <!--end row-->
          </div>
          <!--end col-->
        </div>
        <!--end row-->
      </div>
      <!--end col-->
  
      <div class="col-lg-6 col-md-6 mt-4 mt-lg-0 pt- pt-lg-0">
        <div class="ms-lg-4">
          <div class="section-title mb-4 pb-2">
            <h1 class="mb-4 text-center">{{whatWeDo.title}}</h1>
            <div ngbAccordion activeIds="div ngbAccordionItem-0" closeOthers="true">
              <div *ngFor="let wedo of whatWeDo.paragraph" ngbAccordionItem
                  cardClass="border-0 rounded shadow mb-2">
                  <h2 ngbAccordionHeader>
                      <div class="border-0 bg-light" id="heading{{wedo.id}}">
                          <button ngbAccordionButton class="title mb-0"> {{wedo.title}}
                          </button>
                      </div>
                  </h2>
                  <div ngbAccordionCollapse>
                      <div ngbAccordionBody>
                          <ng-template class="text-muted mb-0 faq-ans">
                            <p *ngFor="let descr of wedo.description">{{descr}}</p>
                          </ng-template>
                      </div>
                  </div>
              </div>
            </div>
            <!-- <p class="text-muted para-desc">Start working with <span class="text-primary fw-bold">Landrick</span> that
              can provide everything you need to generate
              awareness, drive traffic, connect.</p>
            <p class="text-muted para-desc mb-0">The most well-known dummy text is the 'Lorem Ipsum', which is said to
              have originated in the 16th century. Lorem Ipsum is composed in a pseudo-Latin language which more or less
              corresponds to 'proper' Latin. It contains a series of real Latin words.</p> -->
          </div>
  
          <!-- <ul class="list-unstyled text-muted">
            <li class="mb-0"><span class="text-primary h4 me-2"><i
                  class="uil uil-check-circle align-middle"></i></span>Fully Responsive</li>
            <li class="mb-0"><span class="text-primary h4 me-2"><i
                  class="uil uil-check-circle align-middle"></i></span>Multiple Layouts</li>
            <li class="mb-0"><span class="text-primary h4 me-2"><i
                  class="uil uil-check-circle align-middle"></i></span>Suits Your Style</li>
          </ul> -->
  
          <!-- <div class="watch-video mt-4 pt-2">
            <a href="javascript:void(0)" target="_blank" class="btn btn-primary m-1 me-2">Read More
              <i-feather name="chevron-right" class="fea icon-sm"></i-feather>
            </a>
            <a (click)="openWindowCustomClass(content)" href="javascript:void(0);" data-type="youtube"
              data-id="yba7hPeTSjk" class="btn btn-icon btn-pills btn-primary m-1">
              <i-feather name="video" class="icons"></i-feather>
            </a><span class="fw-bold text-uppercase small align-middle ms-1">Watch Now</span>
            <ng-template #content let-modal>
              <div class="modal-header">
                <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <youtube-player [videoId]="'yba7hPeTSjk'" height="450" width="780">
                </youtube-player>
              </div>
            </ng-template>
          </div> -->
        </div>
      </div>
    </div>
    <!--end row-->
  </div>
</section>
<!--end container-->
<!-- About End -->

<!-- CTA START -->
<!-- <section class="section">
  <div class="container">
    <div class="card bg-light rounded border-0 overflow-hidden">
      <div class="row no-gutters align-items-center">
        <div class="col-lg-6">
          <img src="assets/images/coworking/cta.jpg" class="img-fluid" alt="">
        </div>

        <div class="col-lg-6 text-center">
          <div class="card-body section-title p-md-5">
            <a (click)="openWindowCustomClass(content)" href="javascript:void(0);"
              class="play-btn mt-0 border border-light text-center video-play-icon">
              <i-feather name="play" class="fea icon-ex-md text-dark"></i-feather>
            </a>
            <h4 class="title mb-4 mt-4">We Are Creative Dreamers and Co-workers</h4>
            <p class="text-muted mx-auto para-desc mb-0">Start working with Landrick that can provide everything you
              need to generate awareness, drive traffic, connect.</p>
            <ng-template #content let-modal>
              <div class="modal-header">
                <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <youtube-player [videoId]="'yba7hPeTSjk'" height="450" width="780">
                </youtube-player>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>

</section> -->
<!--end section-->
<!-- CTA END -->

<!-- Start Client And Blog -->
<!-- <section class="section bg-light">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12 text-center">
        <div class="section-title mb-4 pb-2">
          <h4 class="title mb-4">Trusted Co-workers</h4>
          <p class="text-muted para-desc mx-auto mb-0">Start working with <span
              class="text-primary fw-bold">Landrick</span> that can provide everything you need to generate awareness,
            drive traffic, connect.</p>
        </div>
      </div>
    </div>

    <div class="row justify-content-center">
      <div class="col-lg-12 mt-4">
        <app-testimonial [testimonialData]="testimonialData"></app-testimonial>
      </div>
    </div>
  </div>
</section> -->
<!--end section-->
<!-- End Client And Blog -->

<section class="section" id="noticias">
  <div class="container">
    <div class="contain-instagram">
    </div>
    <div class="elfsight-app-8da1fb47-ecec-4efd-8fe6-e65895622355" data-elfsight-app-lazy></div>
  </div>
</section>

 <!-- Login Form Start -->
 @for(sucursal of sucursales;track $index){
  <div class="modal fade" id="salas{{sucursal.id}}" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog  modal-xl modal-dialog-centered">
        <div class="modal-content rounded shadow border-0">
          <div class="modal-header border-bottom">
            <h5 class="modal-title" id="LoginForm-title">Sede {{sucursal.title}}</h5>
            <button type="button" class="btn btn-icon btn-close" data-bs-dismiss="modal" id="close-modal"><i class="uil uil-times fs-4 text-dark"></i></button>
          </div>
          <div class="modal-body" style="padding: 3rem;">          
            <div class="row mb-4">
              @for(room of rooms;track $index){
                <div *ngIf="room.sucursalId === sucursal.id" class="col-lg-4 col-md-6 mb-4 mt-4 pt-2">
                  <div class="card border-0 work-container work-primary work-grid position-relative d-block overflow-hidden rounded mb-4">
                    <div class="card-body p-0" style="text-align-last: center;">
                    <a href="javascript:void(0);">
                        <img [src]="room.images[0].urlName" class="img-fluid img-rooms" alt="work-image">
                    </a>
                    <div class="content p-3">
                        <h5 class="mb-0"><a class="text-dark title">{{room.title}}</a></h5>
                        <div class="pt-2 animated fadeInUpBig animation-delay-11 text-center">
                          <a [href]="room.cobotUrl" *ngIf="room.cobotUrl !== '#'" class="btn btn-primary mt-2"><i class="uil uil-transaction"></i> Reserva Ahora</a>
                          <a [href]="room.cobotUrl" *ngIf="room.cobotUrl === '#'" class="btn btn-primary mt-2"><i class="uil uil-transaction"></i> Sold Out</a>
                        </div>
                    </div>
                    </div>
                  </div>
                    <!-- <div class="card blog blog-primary rounded border-0 shadow">
                        <div class="position-relative">
                            <img src="{{data.image}}" class="card-img-top rounded-top" alt="...">
                            <div class="overlay rounded-top"></div>
                        </div>
                        <div class="card-body content">
                            <h5><a href="javascript:void(0)" class="card-title title text-dark">{{data.title}}</a>
                            </h5>
                            <div class="post-meta d-flex justify-content-between mt-3">
                                <ul class="list-unstyled mb-0">
                                    <li class="list-inline-item me-2 mb-0"><a href="javascript:void(0)" class="text-muted like"><i
                                                class="uil uil-heart me-1"></i>{{data.like}}</a></li>
                                    <li class="list-inline-item"><a href="javascript:void(0)" class="text-muted comments"><i
                                                class="uil uil-comment me-1"></i>{{data.message}}</a></li>
                                </ul>
                                <a routerLink="/page-blog-detail" href="javascript:void(0);" class="text-muted readmore">Read More
                                    <i class="uil uil-angle-right-b"></i></a>
                            </div>
                        </div>
                        <div class="author">
                            <small class="user d-block"><i class="uil uil-user"></i> {{data.name}}</small>
                            <small class="date"><i class="uil uil-calendar-alt"></i> {{data.date}}</small>
                        </div>
                    </div> -->
                </div>
              }
            </div>
            <div class="row justify-content-center">
              <div class="col-12 text-center">
                <h2>Ubicación de nuestra Sede {{sucursal.title}} </h2>
              </div>
              <div class="col-12 text-center">
                <div class="section-title mb-4 pb-2 iframe-google-maps" [id]="'mapSede-'+sucursal.id">
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer" style="align-self: center;">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
          </div>
        </div>
    </div>
  </div>
  
}

<!-- Login Form End -->

<!-- WhatsApp button -->
<button class="whatsapp" (click)="goToWs()">
  <span class="">
    <i class="uil uil-whatsapp"></i>
  </span>
</button>
<!-- WhatsApp button -->

<!-- Back to top -->
<a href="javascript: void(0);" class="btn btn-icon btn-primary back-to-top" id="back-to-top" [ngxScrollTo]="'#home'">
  <i-feather name="arrow-up" class="icons"></i-feather>
</a>
<!-- Back to top -->